import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
  importDocument,
} from 'app/components/global';
import editWorkstationDialog from './dialog.editWorkstationDialog';
import deleteWorkstationsDialog from './dialog.deleteWorkstationsDialog';
import controller from './workstations.controller';
import directive from './workstations.directive';
import workstation from './workstation';


export default angular.module('app.components.advisory.bcp.workstations', [
  alerts,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  constants,
  editWorkstationDialog,
  deleteWorkstationsDialog,
  importDocument,
  ssDialogService,
  workstation,
])
  .directive('bcpWorkstations', directive)
  .controller('WorkstationsController', controller)
  .name;

console.log('app.components.advisory.bcp.workstations created');
